<!-- buscar-persona.component.html -->
<div class="buscar-persona-container">
  <mat-form-field appearance="outline" class="w-100">
    <ngx-spinner
      *ngIf="loadBar"
      [zIndex]="-1"
      name="spBusquedaPersona"
      bdColor="rgba(255,255,255,0.8)"
      size="small"
      color="var(--primary-color)"
      type="line-scale"
      [fullScreen]="false">
    </ngx-spinner>

    <mat-label>{{ nombre }}</mat-label>

    <input
      [disabled]="disable"
      type="search"
      placeholder="Buscar por nombre o documento..."
      matInput
      [formControl]="searchControl"
      [matAutocomplete]="auto"
    />

    <button disabled mat-icon-button matSuffix>
      <mat-icon>search</mat-icon>
    </button>

    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayPersona"
      (optionSelected)="onPersonaSelected($event.option.value)">
      <mat-option
        *ngFor="let persona of personas$ | async; trackBy: trackByItems"
        [value]="persona">
        <div class="persona-option">
          <span class="persona-name">{{ persona.nombreCompleto | titlecase }}</span>
          <span class="persona-doc" *ngIf="persona.nroDocumento">
            - {{ persona.nroDocumento }}
          </span>
        </div>
      </mat-option>

      <!-- Opción cuando no hay resultados -->
      <mat-option *ngIf="(personas$ | async)?.length === 0" disabled>
        <span class="no-results">No se encontraron personas</span>
      </mat-option>
    </mat-autocomplete>

    <!-- Botón para editar persona -->
    <button
      mat-icon-button
      matSuffix
      *ngIf="esPersona && personaDetailDto?.id"
      (click)="editarPersona(personaDetailDto.id)"
      matTooltip="Editar persona"
      matTooltipPosition="below"
      type="button">
      <mat-icon color="primary">edit</mat-icon>
    </button>

    <!-- Botón para nueva persona -->
    <button
      mat-icon-button
      matSuffix
      (click)="onNuevaPersona()"
      matTooltip="Nueva persona"
      matTooltipPosition="below"
      type="button">
      <mat-icon color="primary">person_add</mat-icon>
    </button>

    <!-- Botón para limpiar -->
    <button
      mat-icon-button
      matSuffix
      matTooltip="Limpiar selección"
      *ngIf="esPersona"
      (click)="clearSelection()"
      type="button">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>

  <!-- Información de la persona seleccionada -->
  <div class="selected-persona" *ngIf="esPersona && personaEntrada?.nombreCompleto">
    <mat-icon class="selected-icon">person</mat-icon>
    <span class="selected-text">
      <strong>{{ personaEntrada.nombreCompleto | titlecase }}</strong>
      <span *ngIf="personaEntrada.nroDocumento"> - {{ personaEntrada.nroDocumento }}</span>
    </span>
  </div>
</div>
